<div class="container">
  <div class="row">
    <div class="col-lg-6">
      <div id="left" [ngStyle]="{'justify-content': isMobile? 'center' : 'left' }">
        <p class="cr">Copyright © 2021 The Mortgage Calculator</p>
        <!-- <p class="cr">|</p>
        <p class="cr" id="left-item">Terms</p>
        <p class="cr">|</p>
        <p class="cr" id="left-item">Privacy</p> -->
      </div>
    </div>
    <div class="col-lg-6">
      <!-- <div id="right" [ngStyle]="{'justify-content': isMobile? 'center' : 'right' }">
        <p class="list-item">Enquiries</p>
      </div> -->
    </div>
  </div>
</div>
